import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';

import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchDataActive, fetchData, postData, updateData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Button from '@mui/material/Button';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';

//import '../../styles.css';
function BusinessAssociatesIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);

    const [searchTerm, setSearchTerm] = useState('');
    // const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, clubId, branchId, userId, permissions, logout, token } = useAuth();
    const [successMessage, setSuccessMessage] = useState("");
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    //Create Constants---------------------
    const [isSubmit, setIsSubmit] = useState(false);
    const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
    const [name, setPersonName] = useState("");
    const [opening, setOpening] = useState(0);
    const [addressline1, setAddressLine1] = useState("");
    const [address, setAddress] = useState("");
    const [branch, setBranch] = useState("");
    const [accountno, setAccountNo] = useState("");
    const [ifsc, setIFSC] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhonenumber] = useState("");
    const [isbanklist, setIsBankList] = useState(false);
    const [isBank, setIsBank] = useState(false);
    //const [selectedValue, setSelectedValue] = useState("1");
    //-------------------------------------------for edit-------------------
    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false); // For editing
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null); // Holds the person data when editing
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [deletedata, setDeletedata] = useState(null); // To store the ID of the item to delete
    const [clubassociates, setClubAssociteOptions] = useState([]);
    const [selectedassociate, SetSelectedAssociate] = useState("");

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
        fetchtableData1();
    }, [isAuthenticated, clubId, token, logout]);

    // useEffect(() => {
    //     if (searchTerm.trim() == '') {
    //         setFilteredData(data);
    //     } else {
    //         const filtered = data.filter(manu => manu.name.toLowerCase().includes(searchTerm.toLowerCase()));
    //         setFilteredData(filtered);
    //     }
    // }, [data, searchTerm]);


    const optionsn = [
        { value: 1, label: 'Payable' },
        { value: 2, label: 'Receivable' },


    ];
    const [selectedValue, setSelectedValue] = useState(optionsn[0]);
    const fetchtableData = async () => {
        fetchData('PersonApi', `/${branchId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    //setFilteredData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Persons Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const fetchtableData1 = async () => {
        fetchData('ClubAssociatesTypes', `/${clubId}/${branchId}`, token)
            .then((response) => {

                if (response.responseCode === '1111') {

                    const options = response.response_data.map(group => ({
                        value: group.Id,
                        label: group.ClubAssociateType

                    }));
                    setClubAssociteOptions(options);

                } else {
                    console.warn("Expected an array but got:", response.response_data);
                    setClubAssociteOptions([]); // fallback to an empty array to prevent breaking
                }
            })
            .catch((error) => {
                console.error('Error fetching Club Associates Types Details:', error);
            });
    };

    const handleDelete = async () => {

        deleteData('PersonApi', `${deletedata}`, token)

            .then((response) => {
                fetchtableData();
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (pId) => {
        activateData('PersonApi', `${pId}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (id) => {
        setDeletedata(id); // Set the ID of the record to delete
        setConfirmDialogOpen(true); // Open the confirmation dialog
    };

    // Close dialog
    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setDeletedata(null); // Clear the ID
    };


    //Create Section----------------------
    const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        submitData(e);

    }


    const submitData = async (e) => {
        e.preventDefault();

        if (!isSubmit) {
            return;
        }

        if (!name) {
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            return;
        }

        const businessassociates = {
            Name: name,
            PaymentType: selectedValue.value || "",
            Opening: opening,
            Address: address,
            Branch: isBank ? branch : "",
            AccountNo: isBank ? accountno : "",
            IFSC: isBank ? ifsc : "",
            Email: email || "",
            PhoneNumber: phone,
            IsBank: isBank,
            CreatedBy: userId || "",
            CreatedDate: new Date(),
            ClubId: clubId || "",
            BranchId: branchId || "",
            AssociateTypeId: selectedassociate.value || "",

        };
        try {
            const response = await postData('PersonApi', businessassociates, token);
            console.log('Person Created success:', response);
            setSuccessMessage("Person Created successfully!");
            setErrorMessage("");
            // clearForm();
            setTimeout(() => {
                setSuccessMessage("");


            }, 3000);
            window.location.reload();
        } catch (error) {
            console.error('Person Create error:', error);
        }
        setIsModalOpenCreate(prev => !prev);
    };

    const toggleModalCreate = () => {
        setIsModalOpenCreate(prev => !prev);

    };
    const handleChange = (selectedOption) => {
        setSelectedValue(selectedOption);

    };


    //Edit-------------------------

    const toggleModalEdit = () => {
        setIsModalOpenEdit(prev => !prev);
        if (isModalOpenEdit) {
            resetForm(); // Only reset when modal is closing, not opening
            setEditData(null);
            setIsEditing(false);
        }
    };

    // Reset form fields
    const resetForm = () => {
        setPersonName('');
        setOpening('');
        setBranch('');
        setAddress('');

        setPhonenumber('');
        setAccountNo('');
        setIFSC('');
        setEmail('');
        setSelectedValue('1');
        setIsBank(false);
    };

    const handleEdit = (id) => {
        fetchData('PersonApi', `/GetPersonDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const data = response.response_data;
                    setEditData(data); // Store fetched data in state
                    setPersonName(data.name || '');
                    setOpening(data.opening || 0);
                    setBranch(data.branch || '');
                    setAddress(data.address || '');
                    setPhonenumber(data.phoneNumber || '');
                    setAccountNo(data.accountNo || '');
                    setIFSC(data.ifsc || '');
                    setEmail(data.email || '');
                    //setSelectedValue(data.selectedValue || '1');
                    setIsBank(data.isBank || false);
                    setIsEditing(true); // Set editing mode
                    SetSelectedAssociate(data.associateTypeId || ''); // Set the selected associate type

                    const selectedAssociateOption = clubassociates.find(opt => opt.value === data.associateTypeId);
                    SetSelectedAssociate(selectedAssociateOption || null);
                    const selectedPaymentOption = optionsn.find(opt => opt.value === data.paymentType);
                    setSelectedValue(selectedPaymentOption || null);
                    toggleModalEdit();
                } else {
                    console.error('Error fetching person details');
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    const handleFormSubmitEdit = async () => { // Mark the function as async
        if (isEditing && editData) {
            // Update the existing person

            const persondata = {
                Id: editData.id,
                Name: name,
                Opening: opening || 0,
                Address: address || "",
                Branch: isBank ? branch : "",
                AccountNo: isBank ? accountno : "",
                IFSC: isBank ? ifsc : "",
                Email: email || "",
                PhoneNumber: phone || "",
                PaymentType: selectedValue.value,
                ClubId: clubId || "",
                AssociateTypeId: selectedassociate.value || "",
                ModifiedBy: userId || "",
                ModifiedDate: new Date(),
                IsBank: isBank,
            };

            try {
                const response = await updateData('PersonApi', editData.id, persondata, token); // Use editData.id instead of id
                console.log('Record updated successfully:', response);

                // Optional: Show a success message, then clear it after 3 seconds
                setSuccessMessage("Record updated successfully!");
                toggleModalEdit();
                window.location.reload();
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            } catch (error) {
                console.error('Error updating record:', error);
            }
        }
    };


    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('PurchaseOrderDate');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleChange1 = (selectedOption) => {
        SetSelectedAssociate(selectedOption); // Get selected value
        if (selectedOption.value === 1) {
            setIsBank(true);
        }
        else {
            setIsBank(false);
        }
    };
    const filteredByIsBank = filteredData.filter(item => item.isBank === isbanklist);
    const sortedData = stableSort(filteredByIsBank, getComparator(order, orderBy));

    // const sortedData = stableSort(filteredData, getComparator(order, orderBy));
    const commonButtonStyles = {
        height: '36px',
        marginLeft: '10px',
        marginTop: '1.00%',
        marginRight: '8px',
    };




    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">


            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}> BUSINESS ASSOCIATES
                </h6>
                <div mb-2>
                    <input
                        type="checkbox"
                        id="isbanklist"
                        checked={isbanklist}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            setIsBankList(checked);

                        }}

                    />
                </div>
                <label htmlFor="onetime" className="cursor-pointer">Bank List</label>

                <input
                    className="shadow text-gray-700 leading-tight"
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? '250px' : '140px',
                        height: '30px',
                        border: '1px solid #ccc',
                        borderRadius: '15px',
                        padding: '0 20px',
                        transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                        outline: 'none',
                        borderColor: isFocused ? 'darkcyan' : '#ccc',
                        boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        marginLeft: '10px'
                    }}
                />

                <div className="button-container-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Tooltip
                        title="Create BusinessAssociates"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#0e728c',
                                    color: 'white',
                                    border: '1px solid white',
                                    fontWeight: 'bold',
                                    boxShadow: 2,
                                },
                            },
                        }}
                    >
                        <Button
                            component={Link}
                            onClick={toggleModalCreate}
                            className="linkcolor"
                            style={{ color: 'whitesmoke', fontsize: '11px', backgroundColor: '#27391C', height: '25px', marginLeft: '5px' }}
                        >
                            CREATE
                        </Button>
                    </Tooltip>
                </div>



            </div>


            {/* <div className='w-full mb-2 flex'>
                <input
                    ref={inputRef}
                    type="text"
                    placeholder="Search by Business Associates"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                />
            </div> */}


            {isbanklist && (
                <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '0.50%' }}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>

                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>SlNo</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Address</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Branch</TableCell>

                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>IFSC</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Phone</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Email</TableCell>

                                    <TableCell align="right" sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Actions</TableCell>
                                </TableRow>

                            </TableHead>

                            <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                                {sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (

                                    <TableRow
                                        key={data.id}
                                        className={data.isActive ? '' : 'inactiveRow'}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd',// Alternate row background colors
                                        }}
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {index + 1}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {data.name && data.name.length > 25
                                                ? `${data.name.slice(0, 25)}...`
                                                : data.name}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {data.address && data.address.length > 55
                                                ? `${data.address.slice(0, 55)}...`
                                                : data.address}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {data.branch}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {data.ifsc}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {data.phoneNumber}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {data.email}
                                        </TableCell>


                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', height: '20px', padding: '5px', textAlign: 'right', width: '15%' }}>
                                            <Tooltip title="Edit Business Associates">
                                                <Link to="#" onClick={() => handleEdit(data.id)}>
                                                    <IconButton>
                                                        <EditIcon style={{ fontsize: '20px', color: 'blue' }} />
                                                    </IconButton>
                                                </Link>
                                            </Tooltip>
                                            <Tooltip title="Delete Business Associates">
                                                <IconButton
                                                    onClick={() => (data.isActive ? openConfirmDialog(data.id) : handleActivate(data.id))}
                                                >
                                                    {data.isActive ? (
                                                        <DeleteIcon style={{ fontsize: '20px', color: 'brown' }} />
                                                    ) : (
                                                        <ActivateIcon style={{ fontsize: '20px' }} />
                                                    )}
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>


                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete this record?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>
                            </Dialog>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={filteredData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{
                                '& .MuiTablePagination-toolbar': {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap: 'nowrap', // Ensures everything stays in one line
                                    minHeight: '40px', // Keeps a proper height
                                },
                                '& .MuiTablePagination-selectLabel': {
                                    marginBottom: 0, // Fixes label misalignment
                                },
                                '& .MuiTablePagination-displayedRows': {
                                    marginBottom: 0, // Fixes row count misalignment
                                },
                            }}
                        />
                    </TableContainer>
                </div>
            )}



            {!isbanklist && (
                <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '0.50%' }}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>

                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Sl No</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Address</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Phone</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Email</TableCell>

                                    <TableCell align="right" sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Actions</TableCell>
                                </TableRow>

                            </TableHead>

                            <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                                {sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (

                                    <TableRow
                                        key={data.id}
                                        className={data.isActive ? '' : 'inactiveRow'}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd',// Alternate row background colors
                                        }}
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {index + 1}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>

                                            {data.name && data.name.length > 25
                                                ? `${data.name.slice(0, 25)}...`
                                                : data.name}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {data.address && data.address.length > 55
                                                ? `${data.address.slice(0, 55)}...`
                                                : data.address}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {data.phoneNumber}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                                            {data.email}
                                        </TableCell>


                                        <TableCell sx={{ borderBottom: '1px solid #D4E2D4', height: '20px', padding: '5px', textAlign: 'right', width: '15%' }}>
                                            <Tooltip title="Edit Business Associates">
                                                <Link to="#" onClick={() => handleEdit(data.id)}>
                                                    <IconButton>
                                                        <EditIcon style={{ fontsize: '20px', color: 'blue' }} />
                                                    </IconButton>
                                                </Link>
                                            </Tooltip>
                                            <Tooltip title="Delete Business Associates">
                                                <IconButton
                                                    onClick={() => (data.isActive ? openConfirmDialog(data.id) : handleActivate(data.id))}
                                                >
                                                    {data.isActive ? (
                                                        <DeleteIcon style={{ fontsize: '20px', color: 'brown' }} />
                                                    ) : (
                                                        <ActivateIcon style={{ fontsize: '20px' }} />
                                                    )}
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>


                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete this record?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>
                            </Dialog>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={filteredData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{
                                '& .MuiTablePagination-toolbar': {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap: 'nowrap', // Ensures everything stays in one line
                                    minHeight: '40px', // Keeps a proper height
                                },
                                '& .MuiTablePagination-selectLabel': {
                                    marginBottom: 0, // Fixes label misalignment
                                },
                                '& .MuiTablePagination-displayedRows': {
                                    marginBottom: 0, // Fixes row count misalignment
                                },
                            }}
                        />
                    </TableContainer>
                </div>
            )}



            {
                isModalOpenCreate && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '80%' }}>
                            <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', textAlign: 'center', color: '#0e728c' }}>CREATE BUSINESS ASSOCIATES </h6>
                            {/* Radio Buttons for selecting Others or Bank */}
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">


                                    <label className="tracking-wide text-black text-xs font-bold mb-2" htmlFor="parentgroup">Select Business Associate Type</label>
                                    <Select
                                        options={clubassociates}
                                        value={selectedassociate}
                                        onChange={handleChange1}
                                        isSearchable
                                        menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            control: (provided) => ({
                                                ...provided,
                                                width: "100%",
                                                minWidth: 0, // allow shrinking
                                                whiteSpace: "nowrap"
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: "100%",
                                                minWidth: "200px",
                                                whiteSpace: "nowrap",
                                                overflowX: "auto", // Allows horizontal scrolling if needed
                                                overflowY: "hidden", // Disables vertical scrolling
                                                maxHeight: "none"
                                            }),

                                        }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">

                                    <label htmlFor="dropdown" className="tracking-wide text-black text-xs font-bold mb-2">Select Payment Type:</label>
                                    <Select id="dropdown"
                                        value={selectedValue}
                                        options={optionsn}
                                        onChange={handleChange}
                                    />




                                </div>
                            </div>

                            <div className="w-full mb-4 flex">
                                <div className="w-1/2 mr-2">
                                    <label htmlFor="name" className="tracking-wide text-black text-xs font-bold mb-2">
                                        Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={name}
                                        onChange={(e) => setPersonName(e.target.value)}
                                        type="text"
                                        placeholder="Enter Person Name"
                                    />
                                </div>
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="name" className="tracking-wide text-black text-xs font-bold mb-2">
                                        Opening
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"

                                        value={opening}
                                        onChange={(e) => setOpening(e.target.value)}
                                        type="text"
                                        placeholder="Enter Opening"
                                    />
                                </div>
                                <div className="w-1/10 mr-2">
                                  
                                    <label htmlFor="address" className="tracking-wide text-black text-xs font-bold mb-2">Address</label>
                                    <textarea
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder="Enter Address"
                                        rows="1" // Optional: Adjusts the height of the textarea (number of rows)
                                    />




                                </div>
                                <div className="w-1/8 mr-2">
                                    <label htmlFor="name" className="tracking-wide text-black text-xs font-bold mb-2">
                                        Phone No
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={phone}
                                        onChange={(e) => setPhonenumber(e.target.value)}
                                        type="text"
                                        placeholder="Enter  Phone No"
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label htmlFor="name" className="tracking-wide text-black text-xs font-bold mb-2">
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="text"
                                        placeholder="Enter Email"
                                    />
                                </div>
                            </div>


                            {isBank && (
                                <div className="w-full mb-4 flex">
                                    <div className="w-1/8 mr-2">
                                        <label htmlFor="name" className="tracking-wide text-black text-xs font-bold mb-2">
                                            Branch
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={branch}
                                            onChange={(e) => setBranch(e.target.value)}
                                            type="text"
                                            placeholder="Enter Branch"
                                        />
                                    </div>
                                    <div className="w-1/8 mr-2">
                                        <label htmlFor="name" className="tracking-wide text-black text-xs font-bold mb-2">
                                            Account No
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={accountno}
                                            onChange={(e) => setAccountNo(e.target.value)}
                                            type="text"
                                            placeholder="Enter Account No"
                                        />
                                    </div>
                                    <div className="w-1/8 mr-2">
                                        <label htmlFor="name" className="tracking-wide text-black text-xs font-bold mb-2">
                                            IFSC
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={ifsc}
                                            onChange={(e) => setIFSC(e.target.value)}
                                            type="text"
                                            placeholder="Enter IFSC"
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                {/* <Button onClick={handleFormSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }}>
                                Save
                            </Button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }} onClick={toggleModalCreate} >
                                Cancel
                            </button> */}

                                <Button
                                    component={Link}
                                    onClick={handleFormSubmit}
                                    className="linkcolor"
                                    style={{ color: 'whitesmoke', fontsize: '11px', backgroundColor: '#5DB996', height: '25px', marginLeft: '5px' }}
                                >        Save
                                </Button>

                                <Button
                                    component={Link}
                                    onClick={toggleModalCreate}
                                    className="linkcolor"
                                    style={{ color: 'whitesmoke', fontsize: '11px', backgroundColor: '#FF748B', height: '25px', marginLeft: '5px' }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                isModalOpenEdit && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '80%' }}>
                           <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', textAlign: 'center', color: '#0e728c' }}>EDIT BUSINESS ASSOCIATES </h6>
                            {/* Radio Buttons for selecting Others or Bank */}
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">


                                    <label className="tracking-wide text-black text-xs font-bold mb-2" htmlFor="parentgroup">Select Business Associate Type</label>
                                    <Select
                                        options={clubassociates}
                                        value={selectedassociate}
                                        onChange={handleChange1}
                                        isSearchable
                                        menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            control: (provided) => ({
                                                ...provided,
                                                width: "100%",
                                                minWidth: 0, // allow shrinking
                                                whiteSpace: "nowrap"
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: "100%",
                                                minWidth: "200px",
                                                whiteSpace: "nowrap",
                                                overflowX: "auto", // Allows horizontal scrolling if needed
                                                overflowY: "hidden", // Disables vertical scrolling
                                                maxHeight: "none"
                                            }),

                                        }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">

                                    <label className="tracking-wide text-black text-xs font-bold mb-2" htmlFor="dropdown">Select Payment Type:</label>
                                    <Select id="dropdown"
                                        value={selectedValue}
                                        options={optionsn}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Form fields */}
                            <div className="w-full mb-4 flex">
                                <div className="w-1/10 mr-2">
                                    <label className="tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">Name</label>
                                    <input
                                        className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={name}
                                        onChange={(e) => setPersonName(e.target.value)}
                                        type="text"
                                        placeholder="Enter Person Name"
                                    />
                                </div>

                                <div className="w-1/10 mr-2">
                                    <label htmlFor="opening" className="tracking-wide text-black text-xs font-bold mb-2">Opening</label>
                                    <input
                                        className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                        value={opening}
                                        onChange={(e) => setOpening(e.target.value)}
                                        type="text"
                                        placeholder="Enter Opening"
                                    />
                                </div>


                                <div className="w-1/10 mr-2">
                                    <label htmlFor="branchOrAddress" className="tracking-wide text-black text-xs font-bold mb-2">Address</label>

                                       <label htmlFor="address">Address</label>
                                    <textarea
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder="Enter Address"
                                        rows="1" // Optional: Adjusts the height of the textarea (number of rows)
                                    />
                                  
                                </div>

                                <div className="w-1/10 mr-2">
                                    <label htmlFor="branchOrAddress" className="tracking-wide text-black text-xs font-bold mb-2">Phone No</label>
                                    <input
                                        className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={phone}
                                        onChange={(e) => setPhonenumber(e.target.value)}
                                        type="text"
                                        placeholder={"Enter Phone No"}
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label htmlFor="email" className="tracking-wide text-black text-xs font-bold mb-2">Email</label>
                                    <input
                                        className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="text"
                                        placeholder="Enter Email"
                                    />
                                </div>
                            </div>
                            {isBank && (
                                <div className="w-full mb-4 flex">
                                    <div className="w-1/8 mr-2">
                                        <label htmlFor="accountOrPhone1" className="tracking-wide text-black text-xs font-bold mb-2">Account No</label>
                                        <input
                                            className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={accountno}
                                            onChange={(e) => setAccountNo(e.target.value)}
                                            type="text"
                                            placeholder={"Enter Account No"}
                                        />
                                    </div>
                                    <div className="w-1/10 mr-2">
                                        <label htmlFor="branchOrAddress" className="tracking-wide text-black text-xs font-bold mb-2">"Branch"</label>
                                        <input
                                            className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={branch}
                                            onChange={(e) => setBranch(e.target.value)}
                                            type="text"
                                            placeholder={"Enter Branch"}
                                        />
                                    </div>
                                    <div className="w-1/8 mr-2">
                                        <label htmlFor="ifscOrPhone2" className="tracking-wide text-black text-xs font-bold mb-2">IFSC</label>
                                        <input
                                            className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={ifsc}
                                            onChange={(e) => setIFSC(e.target.value)}
                                            type="text"
                                            placeholder={"Enter IFSC"}
                                        />
                                    </div>


                                </div>)}

                            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>

                                <Button
                                    component={Link}
                                    onClick={handleFormSubmitEdit}
                                    className="linkcolor"
                                    style={{
                                        color: 'whitesmoke', fontsize: '11px', backgroundColor: '#5DB996', height: '25px',
                                        marginLeft: '5px'
                                    }}
                                >



                                    Update
                                </Button>
                                <Button
                                    component={Link}
                                    onClick={toggleModalEdit}
                                    className="linkcolor"
                                    style={{
                                        color: 'whitesmoke', fontsize: '11px', backgroundColor: '#FF748B', height: '25px',
                                        marginLeft: '5px'
                                    }}
                                >

                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>
                )
            }

        </div >
    );
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}



export default BusinessAssociatesIndex;




